import { initArchiveSubjectNavigation } from '../../_shared/archive-subject-navigation';

const BLOCK_SELECTOR = '.wp-block-fc-block-fc-knowledge-hub-listing';

const initKnowledgeHubListings = () => {
	document.querySelectorAll(BLOCK_SELECTOR).forEach((block) => {
		initArchiveSubjectNavigation(block);
	});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initKnowledgeHubListings);
} else {
	initKnowledgeHubListings();
}
